import { DehydratedState, QueryClientConfig } from 'react-query'

const defaultConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      cacheTime: Infinity,
      staleTime: Infinity,
      retry: false,
    },
  },
}

const dehydrateQueryStateWithNowTimestamp = (
  dehydratedQueryState?: DehydratedState
): DehydratedState | undefined =>
  dehydratedQueryState
    ? {
        ...dehydratedQueryState,
        queries: dehydratedQueryState.queries.map((query) => ({
          ...query,
          state: { ...query.state, dataUpdatedAt: Date.now() },
        })),
      }
    : dehydratedQueryState

export { defaultConfig, dehydrateQueryStateWithNowTimestamp }
